import { SignatureComponent } from './signature.component';

export default angular
  .module('sfMobile.components.signature', [])
  .component('sfSignature', SignatureComponent).name;
